export const getAllPessoas = () =>
  JSON.parse(sessionStorage.getItem("pessoas_fisicas"));
export const setAllPessoas = (data) => {
  sessionStorage.setItem("pessoas_fisicas", JSON.stringify(data));
};
